import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Stack, TextField, PrimaryButton } from '@fluentui/react';
import { usePromise } from '../../../../Common/hooks/usePromise';
import { DefaultLoadingHubButton } from '../../../../HubLayout/components/Utilities/DefaultLoadingHubButton';
import { JsonResult } from '../../../../HubLayout/components/Utilities/JsonResult';
import { activateArtifact } from '../../../../AGSS/api/AGSSApi';
import { ThemeContext } from '../../../../HubLayout/models/ThemeContext';
import { getThemeFromString } from '../../../../Common/util/localStorageUtils';

interface IActivateArtifactProps {}

export const ActivateArtifact: React.FC<IActivateArtifactProps> = (
    props: IActivateArtifactProps
) => {
    const themeContext = useContext(ThemeContext);
    const theme = getThemeFromString(themeContext.themeName);
    const stackTokens = { childrenGap: 16 };

    const [artifactIdValue, setArtifactIdValue] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleArtifactIdChange = (
        event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
        newValue?: string | undefined
    ) => {
        setArtifactIdValue(newValue ?? '');
    };

    const activateArtifactCallback = useCallback(async () => {
        if (artifactIdValue) {
            const result = await activateArtifact(artifactIdValue);
            setIsLoading(false);
            return result;
        }
    }, [artifactIdValue]);

    const [result, error, isLoaded, start, cancel] = usePromise(
        activateArtifactCallback,
        false
    );

    const handleActivateArtifactClick = () => {
        setIsLoading(true);
        start();
    };

    return (
        <Stack tokens={stackTokens}>
            <div
                style={{
                    padding: '12px',
                    backgroundColor: theme.palette.white,
                    borderRadius: '4px',
                    border: `1px solid ${theme.palette.neutralTertiaryAlt}`,
                }}
            >
                <TextField
                    label="Artifact ID"
                    placeholder="Enter the artifact ID"
                    value={artifactIdValue}
                    onChange={handleArtifactIdChange}
                    borderless
                />
            </div>

            <Stack horizontal tokens={{ childrenGap: 12 }}>
                <PrimaryButton
                    text="Activate Artifact"
                    iconProps={{ iconName: 'ReceiptCheck' }}
                    onClick={handleActivateArtifactClick}
                    disabled={isLoading || !artifactIdValue}
                />
            </Stack>

            <JsonResult data={result} />
        </Stack>
    );
};
